/* size-by-length + variant URL bust 1791385000 */
(function () {
  const root = document.querySelector("[data-pdp]");
  if (!root) return;

  const variants = JSON.parse(root.querySelector("[data-pdp-variants]").textContent || "[]");
  const idInput = root.querySelector("[data-pdp-id]");
  const mainImage = root.querySelector("[data-pdp-main]");
  const priceNode = root.querySelector("[data-pdp-price]");
  const compareNode = root.querySelector("[data-pdp-compare]");
  const offNode = root.querySelector("[data-pdp-off]");
  const atc = root.querySelector("[data-pdp-atc]");
  const qtyInput = root.querySelector("[data-pdp-qty]");
  const added = root.querySelector("[data-pdp-added]");
  const offerNote = root.querySelector("[data-pdp-offer-note]");
  const measure = root.querySelector("[data-pdp-measure]");
  const thumbs = root.querySelector("[data-pdp-thumbs]");
  const currency = root.dataset.currency || "USD";
  const money = new Intl.NumberFormat("en-US", { style: "currency", currency });

  const urlVariantId = new URLSearchParams(window.location.search).get("variant");
  let current =
    (urlVariantId && variants.find((item) => String(item.id) === String(urlVariantId))) ||
    variants.find((item) => String(item.id) === String(idInput && idInput.value)) ||
    variants[0];

  function format(cents) {
    return money.format((cents || 0) / 100);
  }

  function syncVariantUrl(variant) {
    if (!variant || !variant.id) return;
    try {
      const url = new URL(window.location.href);
      const id = String(variant.id);
      if (url.searchParams.get("variant") === id) return;
      url.searchParams.set("variant", id);
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  function paint(variant) {
    if (!variant) return;
    current = variant;
    if (idInput) idInput.value = variant.id;
    syncVariantUrl(variant);
    if (priceNode) priceNode.textContent = format(variant.price);
    if (compareNode) {
      const show = variant.compare && variant.compare > variant.price;
      compareNode.hidden = !show;
      if (show) compareNode.textContent = format(variant.compare);
    }
    if (offNode) {
      const show = variant.compare && variant.compare > variant.price;
      offNode.hidden = !show;
      if (show) offNode.textContent = Math.round((1 - variant.price / variant.compare) * 100) + "% OFF";
    }
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? "ADD TO CART" : "SOLD OUT";
    }
    root.querySelectorAll("[data-vmodal-price]").forEach((node) => {
      node.textContent = format(variant.price);
    });
    root.querySelectorAll("[data-vmodal-compare]").forEach((node) => {
      const show = variant.compare && variant.compare > variant.price;
      node.hidden = !show;
      if (show) node.textContent = format(variant.compare);
    });
    root.querySelectorAll("[data-vmodal-atc].pdp-atc").forEach((button) => {
      button.disabled = !variant.available;
      button.textContent = variant.available ? "ADD TO CART" : "SOLD OUT";
    });
    if (mainImage && variant.image) {
      mainImage.removeAttribute("srcset");
      mainImage.src = variant.image;
    }
    const thumb = thumbFor(variant.image);
    if (thumb) revealThumb(thumb);
    const colorLabel = root.querySelector("[data-pdp-color]");
    const colorProbe = root.querySelector(".pdp-swatch[data-option-index]");
    if (colorLabel && colorProbe) colorLabel.textContent = variant.options[Number(colorProbe.dataset.optionIndex)] || "";
    const sizeLabel = root.querySelector("[data-pdp-size-label]");
    const sizeProbe = root.querySelector("[data-pdp-size]");
    if (sizeLabel && sizeProbe) sizeLabel.textContent = variant.options[Number(sizeProbe.dataset.optionIndex)] || "";
    const lengthLabel = root.querySelector("[data-pdp-length-label]");
    const lengthProbe = root.querySelector("[data-pdp-length]");
    if (lengthLabel && lengthProbe) lengthLabel.textContent = variant.options[Number(lengthProbe.dataset.optionIndex)] || "";
    root.querySelectorAll("[data-pdp-option]").forEach((button) => {
      const index = Number(button.dataset.optionIndex);
      const active = variant.options[index] === button.dataset.value;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
    syncLengthUI(variant);
    refreshSwatchHrefs(variant);
    root.querySelectorAll("[data-pdp-size-row]").forEach((row) => {
      const panel = row.closest("[data-pdp-chart-panel]");
      if (panel && panel.hidden) return;
      row.classList.toggle("is-active", row.dataset.size === variant.options[sizeIndex()]);
    });
    paintMeasure();
    if (added) added.hidden = true;
  }

  function sizeIndex() {
    const button = root.querySelector("[data-pdp-size]");
    return button ? Number(button.dataset.optionIndex) : -1;
  }

  function lengthIndex() {
    const button = root.querySelector("[data-pdp-length]");
    return button ? Number(button.dataset.optionIndex) : -1;
  }

  function colorIndex() {
    const button = root.querySelector("[data-pdp-swatch], .pdp-swatch[data-option-index]");
    return button ? Number(button.dataset.optionIndex) : -1;
  }

  function selectedSize() {
    const index = sizeIndex();
    return index >= 0 ? current.options[index] : "";
  }

  function selectedLength() {
    const index = lengthIndex();
    return index >= 0 ? current.options[index] : "";
  }

  function chartRow(size) {
    const length = selectedLength();
    if (length) {
      const panel = root.querySelector('[data-pdp-chart-panel][data-length="' + CSS.escape(length) + '"]:not([hidden])')
        || root.querySelector('[data-pdp-chart-panel][data-length="' + CSS.escape(length) + '"]');
      if (panel) {
        const row = panel.querySelector('[data-pdp-size-row][data-size="' + CSS.escape(size) + '"]');
        if (row) return row;
      }
    }
    return root.querySelector('[data-pdp-chart-panel]:not([hidden]) [data-pdp-size-row][data-size="' + CSS.escape(size) + '"]')
      || root.querySelector('[data-pdp-size-row][data-size="' + CSS.escape(size) + '"]');
  }

  function syncLengthUI(variant) {
    const li = lengthIndex();
    if (li < 0) return;
    const length = variant.options[li] || "";
    const ci = colorIndex();
    root.querySelectorAll("[data-pdp-swatch]").forEach((button) => {
      const lengths = (button.dataset.lengths || "").split(",").map((s) => s.trim()).filter(Boolean);
      const show = !lengths.length || lengths.includes(length);
      button.hidden = !show;
      button.classList.toggle("is-length-hidden", !show);
    });
    root.querySelectorAll("[data-pdp-chart-panel]").forEach((panel) => {
      const match = !panel.dataset.length || panel.dataset.length === length;
      panel.hidden = !match;
      panel.classList.toggle("is-active", match);
    });
    const si = sizeIndex();
    root.querySelectorAll("[data-pdp-size]").forEach((button) => {
      const size = button.dataset.value;
      const show = !length || si < 0 || variants.some((item) => item.options[li] === length && item.options[si] === size);
      button.hidden = !show;
      button.classList.toggle("is-length-hidden", !show);
    });
    const color = ci >= 0 ? variant.options[ci] : "";
    const thumbs = Array.from(root.querySelectorAll("[data-pdp-thumb]"));
    let firstVisible = null;
    thumbs.forEach((thumb) => {
      const tLen = thumb.dataset.length || "";
      const tColor = thumb.dataset.color || "";
      const lengthOk = !tLen || tLen === length;
      const colorOk = !color || !tColor || tColor === color;
      // Show all images for selected length; prefer color match for main, but keep length gallery browsable
      const show = lengthOk;
      thumb.hidden = !show;
      thumb.classList.toggle("is-length-hidden", !show);
      if (show && !firstVisible) firstVisible = thumb;
      if (show && color && tColor === color && !thumb.dataset._colorPreferred) {
        firstVisible = thumb;
        thumb.dataset._colorPreferred = "1";
      }
    });
    thumbs.forEach((t) => delete t.dataset._colorPreferred);
    // Prefer thumb matching length+color
    let preferred = thumbs.find((t) => !t.hidden && t.dataset.color === color && (!t.dataset.length || t.dataset.length === length));
    if (!preferred) preferred = thumbs.find((t) => !t.hidden && (!t.dataset.length || t.dataset.length === length));
    if (preferred && mainImage) {
      const active = root.querySelector("[data-pdp-thumb].is-active");
      if (!active || active.hidden || (variant.image && imageKey(active.dataset.src) !== imageKey(variant.image))) {
        // keep variant.image as source of truth when present
        if (!variant.image) {
          preferred.click();
        }
      }
    }
    // Refresh stage arrow state against visible thumbs
    paintStage();
  }

  function setMeasure(text) {
    if (!measure) return;
    measure.replaceChildren();
    if (!text) return;
    String(text).split(" · ").forEach((part) => {
      if (!part) return;
      const el = document.createElement("span");
      el.className = "pdp-measure-part";
      el.textContent = part;
      measure.append(el);
    });
  }


  function refreshSwatchHrefs(variant) {
    const ci = colorIndex();
    const li = lengthIndex();
    const si = sizeIndex();
    if (ci < 0) return;
    const length = li >= 0 ? variant.options[li] : null;
    const size = si >= 0 ? variant.options[si] : null;
    const path = window.location.pathname;
    root.querySelectorAll("[data-pdp-swatch]").forEach((button) => {
      const color = button.dataset.value;
      const match =
        variants.find((item) => item.options[ci] === color && (li < 0 || item.options[li] === length) && (si < 0 || item.options[si] === size)) ||
        variants.find((item) => item.options[ci] === color && (li < 0 || item.options[li] === length)) ||
        variants.find((item) => item.options[ci] === color);
      if (match) button.setAttribute("data-href", path + "?variant=" + match.id);
    });
  }

  function paintMeasure() {
    if (!measure) return;
    const size = selectedSize();
    const cups = [];
    const listed = root.querySelector("[data-pdp-chart]") || root;
    root.querySelectorAll("[data-alpha]").forEach((cell) => {
      cell.classList.toggle("is-size", cell.dataset.alpha === size);
    });
    if (root.querySelector("[data-alpha]")) {
      listed.querySelectorAll("[data-alpha]").forEach((cell) => {
        if (cell.dataset.alpha === size && cell.dataset.bra) cups.push(cell.dataset.bra);
      });
      setMeasure(cups.length ? cups.join(" · ") : "");
      return;
    }
    const row = chartRow(size);
    if (!row) {
      setMeasure("");
      return;
    }
    const unit = root.dataset.unit || "in";
    if (row.dataset.fit === "true") {
      const under = unit === "cm" ? row.dataset.underCm : row.dataset.underIn;
      setMeasure(row.dataset.cups + " · Under bust " + under + " · US " + row.dataset.us);
      return;
    }
    if (row.dataset.waist === "true" && row.dataset.waistIn) {
      const waist = unit === "cm" ? row.dataset.waistCm : row.dataset.waistIn;
      const hip = unit === "cm" ? row.dataset.hipCm : row.dataset.hipIn;
      const parts = [];
      if (row.dataset.heightIn) {
        const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
        const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
        parts.push("Height " + height + " " + (unit === "cm" ? "cm" : "in"));
        parts.push("Weight " + weight + " " + (unit === "cm" ? "kg" : "lb"));
      } else if (row.dataset.weightIn) {
        const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
        parts.push("Weight " + weight + " " + (unit === "cm" ? "kg" : "lb"));
      }
      if (row.dataset.us) parts.push("US " + row.dataset.us);
      parts.push("Waist " + waist);
      parts.push("Hip " + hip);
      if (row.dataset.lengthIn) parts.push("Length " + (unit === "cm" ? row.dataset.lengthCm : row.dataset.lengthIn));
      setMeasure(parts.join(" · "));
      return;
    }
    if (row.dataset.set === "true") {
      const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
      const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
      const bust = unit === "cm" ? row.dataset.bustCm : row.dataset.bustIn;
      const waist = unit === "cm" ? row.dataset.waistCm : row.dataset.waistIn;
      const top = unit === "cm" ? row.dataset.topCm : row.dataset.topIn;
      const shorts = unit === "cm" ? row.dataset.shortCm : row.dataset.shortIn;
      const hUnit = unit === "cm" ? "cm" : "in";
      const wUnit = unit === "cm" ? "kg" : "lb";
      setMeasure("Height " + height + " " + hUnit + " · Weight " + weight + " " + wUnit + " · Bust " + bust + " · Waist " + waist + " · Cami " + top + " · Shorts " + shorts);
      return;
    }
    if (row.dataset.tights === "true") {
      const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
      const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
      setMeasure("Height " + height + " · Weight " + weight + " · " + row.dataset.us);
      return;
    }
    if (row.dataset.spec === "true") {
      const labels = (row.dataset.specLabels || "").split("|");
      const vals = ((unit === "cm" ? row.dataset.specCm : row.dataset.specIn) || "").split("|");
      const parts = [];
      labels.forEach((label, i) => { const v = (vals[i] || "").trim(); if (label && v && v !== "—" && v !== "-") parts.push(label + " " + v); });
      setMeasure(parts.join(" · "));
      return;
    }
    if (row.dataset.garment === "true") {
      const bust = unit === "cm" ? row.dataset.bustCm : row.dataset.bustIn;
      const waist = unit === "cm" ? row.dataset.waistCm : row.dataset.waistIn;
      const hip = unit === "cm" ? row.dataset.hipCm : row.dataset.hipIn;
      const length = unit === "cm" ? row.dataset.lengthCm : row.dataset.lengthIn;
      const dash = (v) => !v || v === "—" || v === "–" || v === "-" || v === "—";
      let parts = [];
      if (row.dataset.heightIn) {
        const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
        const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
        const hUnit = unit === "cm" ? "cm" : "in";
        const wUnit = unit === "cm" ? "kg" : "lb";
        parts.push("Height " + height + " " + hUnit);
        parts.push("Weight " + weight + " " + wUnit);
      }
      if (!dash(bust)) parts.push("Bust " + bust);
      if (!dash(waist) && row.dataset.garmentBl !== "true") parts.push("Waist " + waist);
      if (!dash(hip) && row.dataset.garmentBl !== "true") parts.push("Hip " + hip);
      const shoulder = unit === "cm" ? row.dataset.shoulderCm : row.dataset.shoulderIn;
      if (!dash(shoulder)) parts.push("Shoulder " + shoulder);
      if (!dash(length)) parts.push("Length " + length);
      setMeasure(parts.join(" · "));
      return;
    }
    if (row.dataset.curve === "true") {
      const bust = unit === "cm" ? row.dataset.bustCm : row.dataset.bustIn;
      const waist = unit === "cm" ? row.dataset.waistCm : row.dataset.waistIn;
      const hip = unit === "cm" ? row.dataset.hipCm : row.dataset.hipIn;
      let text = "US " + row.dataset.us + " · Bust " + bust + " · Waist " + waist + " · Hip " + hip;
      if (row.dataset.heightIn) {
        const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
        const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
        const hUnit = unit === "cm" ? "cm" : "in";
        const wUnit = unit === "cm" ? "kg" : "lb";
        text += " · Height " + height + " " + hUnit + " · Weight " + weight + " " + wUnit;
      }
      setMeasure(text);
      return;
    }
    if (row.dataset.shaper === "true") {
      const bust = unit === "cm" ? row.dataset.bustCm : row.dataset.bustIn;
      const under = unit === "cm" ? row.dataset.underCm : row.dataset.underIn;
      setMeasure(row.dataset.cup + " · Bust " + bust + " · Underbust " + under);
      return;
    }
    if (row.dataset.hw === "true") {
      const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
      const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
      const hUnit = unit === "cm" ? "cm" : "in";
      const wUnit = unit === "cm" ? "kg" : "lb";
      let text = "Height " + height + " " + hUnit + " · Weight " + weight + " " + wUnit;
      if (row.dataset.waistIn) {
        const waist = unit === "cm" ? row.dataset.waistCm : row.dataset.waistIn;
        const leg = unit === "cm" ? row.dataset.legCm : row.dataset.legIn;
        text += " · Waist " + waist + " " + unit + " · Leg " + leg + " " + unit;
      }
      setMeasure(text);
      return;
    }
    if (row.dataset.body === "true") {
      const suffix = unit === "cm" ? "Cm" : "In";
      const unitName = unit === "cm" ? "cm" : "in";
      setMeasure(["Bust", "Waist", "Hip", "Height"].map((label) => {
        const value = row.dataset[label.toLowerCase() + suffix];
        return label + " " + value + " " + unitName;
      }).join(" · "));
      return;
    }
    const bust = row.dataset["bust" + (unit === "cm" ? "Cm" : "In")];
    const waist = row.dataset["waist" + (unit === "cm" ? "Cm" : "In")];
    let text = "Bust " + bust + " " + unit + " · Waist " + waist + " " + unit;
    if (row.dataset.heightIn) {
      const height = unit === "cm" ? row.dataset.heightCm : row.dataset.heightIn;
      const weight = unit === "cm" ? row.dataset.weightCm : row.dataset.weightIn;
      const hUnit = unit === "cm" ? "cm" : "in";
      const wUnit = unit === "cm" ? "kg" : "lb";
      text += " · Height " + height + " " + hUnit + " · Weight " + weight + " " + wUnit;
    }
    setMeasure(text);
  }

  function imageKey(url) {
    if (!url) return "";
    const path = String(url).split("?")[0].split("/").pop() || "";
    return path.replace(/_(?:\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i, "");
  }

  function thumbFor(url) {
    const key = imageKey(url);
    if (!key) return null;
    return Array.from(root.querySelectorAll("[data-pdp-thumb]")).find((button) => imageKey(button.dataset.src) === key) || null;
  }

  function revealThumb(button) {
    root.querySelectorAll("[data-pdp-thumb]").forEach((item) => item.classList.toggle("is-active", item === button));
    const scroller = root.querySelector("[data-pdp-thumbs]");
    if (!scroller) return;
    const scrollerBox = scroller.getBoundingClientRect();
    const thumbBox = button.getBoundingClientRect();
    const delta = thumbBox.left + thumbBox.width / 2 - (scrollerBox.left + scrollerBox.width / 2);
    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const left = Math.min(max, Math.max(0, scroller.scrollLeft + delta));
    scroller.scrollTo({ left, behavior: "smooth" });
    window.setTimeout(() => {
      if (Math.abs(scroller.scrollLeft - left) > 2) scroller.scrollLeft = left;
    }, 80);
    window.setTimeout(paintStage, 0);
  }

  function setUnit(unit) {
    root.dataset.unit = unit;
    root.querySelectorAll("[data-pdp-unit]").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.pdpUnit === unit);
      button.setAttribute("aria-pressed", button.dataset.pdpUnit === unit ? "true" : "false");
    });
    root.querySelectorAll("[data-cm]").forEach((cell) => {
      cell.textContent = unit === "cm" ? cell.dataset.cm : cell.dataset.in;
    });
    root.querySelectorAll("[data-pdp-unit-label]").forEach((node) => {
      if (node.dataset.cup === "true") return;
      if (node.dataset.waist === "true") {
        node.textContent = "Body measurements in " + unit;
        return;
      }
      if (node.dataset.tights === "true") {
        node.textContent = unit === "cm"
          ? "Suggested height in cm, weight in kg."
          : "Suggested height in inches, weight in pounds.";
        return;
      }
      if (node.dataset.hwGuide === "true") {
        node.textContent = "Size guide \u00b7 garment measurements in " + unit + (unit === "cm" ? ", weight in kg" : ", weight in lb");
        return;
      }
      if (node.dataset.garment === "true") {
        node.textContent = "Garment measurements in " + unit;
        return;
      }
      if (node.dataset.shaper === "true") {
        node.textContent = "Body measurements in " + unit;
        return;
      }
      if (node.dataset.hw === "true") {
        node.textContent = unit === "cm" ? "Height in cm, weight in kg" : "Height in inches, weight in pounds";
        return;
      }
      node.textContent = "Measurements in " + unit;
    });
    root.querySelectorAll("[data-pdp-strap-note]").forEach((node) => {
      node.hidden = node.dataset.forUnit !== unit;
    });
    paintMeasure();
  }

  root.querySelectorAll("[data-pdp-option]").forEach((button) => {
    button.addEventListener("click", () => {
      const index = Number(button.dataset.optionIndex);
      const next = current.options.slice();
      next[index] = button.dataset.value;
      let match =
        variants.find((item) => item.options.every((value, i) => value === next[i])) ||
        variants.find((item) => item.options[index] === button.dataset.value && item.available) ||
        variants.find((item) => item.options[index] === button.dataset.value);
      // Length change: keep color/size when valid; otherwise fall back (e.g. Long 3XL → Short has no 3XL)
      const li = lengthIndex();
      const ci = colorIndex();
      const si = sizeIndex();
      if (match && li >= 0 && index === li) {
        const length = button.dataset.value;
        const wantColor = ci >= 0 ? next[ci] : null;
        const wantSize = si >= 0 ? next[si] : null;
        const colorOk = ci < 0 || variants.some((item) => item.options[li] === length && item.options[ci] === wantColor);
        const sizeOk = si < 0 || variants.some((item) => item.options[li] === length && item.options[si] === wantSize);
        if (!colorOk || !sizeOk) {
          const fallback =
            variants.find((item) => item.options[li] === length && (ci < 0 || item.options[ci] === wantColor) && (si < 0 || item.options[si] === wantSize) && item.available) ||
            variants.find((item) => item.options[li] === length && (ci < 0 || item.options[ci] === wantColor) && (si < 0 || item.options[si] === wantSize)) ||
            variants.find((item) => item.options[li] === length && (ci < 0 || item.options[ci] === wantColor) && item.available) ||
            variants.find((item) => item.options[li] === length && (ci < 0 || item.options[ci] === wantColor)) ||
            variants.find((item) => item.options[li] === length && item.available) ||
            variants.find((item) => item.options[li] === length);
          if (fallback) match = fallback;
        }
      }
      paint(match);
    });
  });

  root.querySelectorAll("[data-pdp-thumb]").forEach((button) => {
    button.addEventListener("click", () => {
      if (mainImage) {
        mainImage.removeAttribute("srcset");
        mainImage.src = button.dataset.src;
      }
      root.querySelectorAll("[data-pdp-thumb]").forEach((item) => item.classList.toggle("is-active", item === button));
      revealThumb(button);
    });
  });

  function visibleThumbs() {
    return Array.from(root.querySelectorAll("[data-pdp-thumb]")).filter((item) => !item.hidden);
  }
  function paintStage() {
    const images = visibleThumbs();
    const index = images.findIndex((item) => item.classList.contains("is-active"));
    const prev = root.querySelector("[data-pdp-prev]");
    const next = root.querySelector("[data-pdp-next]");
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index < 0 || index >= images.length - 1;
  }
  function shift(delta) {
    const images = visibleThumbs();
    if (!images.length || !mainImage) return;
    let index = images.findIndex((item) => item.classList.contains("is-active"));
    if (index < 0) index = 0;
    const next = index + delta;
    if (next < 0 || next >= images.length) return;
    images[next].click();
  }
  root.querySelector("[data-pdp-prev]")?.addEventListener("click", () => shift(-1));
  root.querySelector("[data-pdp-next]")?.addEventListener("click", () => shift(1));
  root.querySelectorAll("[data-pdp-thumb]").forEach((button) => {
    button.addEventListener("click", () => window.setTimeout(paintStage, 0));
  });
  paintStage();

  function bindRow(node, prevSelector, nextSelector) {
    if (!node) return;
    const prev = root.querySelector(prevSelector);
    const next = root.querySelector(nextSelector);
    function contentMax() {
      const box = node.clientWidth;
      if (box < 2) return -1;
      const kids = Array.from(node.children);
      const gap = parseFloat(getComputedStyle(node).columnGap || getComputedStyle(node).gap) || 0;
      let width = 0;
      kids.forEach((kid) => {
        width += kid.getBoundingClientRect().width;
      });
      if (kids.length > 1) width += gap * (kids.length - 1);
      const byScroll = Math.max(0, node.scrollWidth - box);
      const byKids = Math.max(0, width - box);
      return Math.max(byScroll, byKids);
    }
    function paint() {
      const max = contentMax();
      if (max < 0) return;
      if (prev) prev.disabled = node.scrollLeft <= 2;
      if (next) next.disabled = node.scrollLeft >= max - 2;
    }
    function move(delta) {
      const max = contentMax();
      if (max < 1) return;
      const start = node.scrollLeft;
      const left = Math.min(max, Math.max(0, start + delta));
      try {
        node.scrollTo({ left, behavior: "smooth" });
      } catch (error) {
        node.scrollLeft = left;
      }
      window.setTimeout(() => {
        if (Math.abs(node.scrollLeft - start) < 1 && Math.abs(left - start) > 1) node.scrollLeft = left;
        paint();
      }, 70);
    }
    prev?.addEventListener("click", () => move(-Math.max(160, node.clientWidth * 0.8)));
    next?.addEventListener("click", () => move(Math.max(160, node.clientWidth * 0.8)));
    node.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint);
    window.addEventListener("load", paint);
    if ("IntersectionObserver" in window) {
      const watcher = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) paint();
      });
      watcher.observe(node);
    }
    node.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", paint, { once: true });
    });
    requestAnimationFrame(() => requestAnimationFrame(paint));
    paint();
  }
  bindRow(root.querySelector("[data-pdp-thumbs]"), "[data-scroll-thumbs='-1']", "[data-scroll-thumbs='1']");
  bindRow(root.querySelector("[data-pdp-reviews]"), "[data-scroll-reviews='-1']", "[data-scroll-reviews='1']");
  bindRow(root.querySelector("[data-pdp-ladies]"), "[data-scroll-ladies='-1']", "[data-scroll-ladies='1']");
  root.querySelector("[data-scroll-top]")?.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));

  const reviewList = root.querySelector("[data-avr-list]");
  if (reviewList) {
    const cards = Array.from(reviewList.children);
    const perPage = 4;
    const pageCount = Math.max(1, Math.ceil(cards.length / perPage));
    const pager = root.querySelector("[data-avr-pages]");
    const status = root.querySelector("[data-avr-status]");
    const prev = root.querySelector("[data-avr-prev]");
    const next = root.querySelector("[data-avr-next]");
    let page = 0;
    function showReviews() {
      cards.forEach((card, index) => {
        card.hidden = index < page * perPage || index >= (page + 1) * perPage;
      });
      if (pager) pager.hidden = pageCount < 2;
      if (status) status.textContent = page + 1 + " / " + pageCount;
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= pageCount - 1;
    }
    prev?.addEventListener("click", () => {
      page = Math.max(0, page - 1);
      showReviews();
    });
    next?.addEventListener("click", () => {
      page = Math.min(pageCount - 1, page + 1);
      showReviews();
    });
    showReviews();
  }

  if (thumbs) {
    thumbs.addEventListener(
      "wheel",
      (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        thumbs.scrollLeft += event.deltaY;
      },
      { passive: false },
    );
  }

  function syncOffer() {
    if (!offerNote) return;
    const qty = Math.max(1, Number(qtyInput.value) || 1);
    const base = offerNote.dataset.base || "";
    offerNote.textContent = qty >= 3 ? base + " This set qualifies." : base + " Add " + (3 - qty) + " more to unlock it.";
  }
  root.querySelector("[data-qty='-1']")?.addEventListener("click", () => {
    qtyInput.value = String(Math.max(1, Number(qtyInput.value) - 1));
    syncOffer();
  });
  root.querySelector("[data-qty='1']")?.addEventListener("click", () => {
    qtyInput.value = String(Number(qtyInput.value) + 1);
    syncOffer();
  });
  qtyInput?.addEventListener("change", syncOffer);

  let addedTimer;
  function openAdded() {
    const toast = root.querySelector("[data-added-toast]");
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(addedTimer);
    addedTimer = setTimeout(() => {
      toast.hidden = true;
    }, 2200);
  }

  function closeAdded() {
    const toast = root.querySelector("[data-added-toast]");
    if (toast) toast.hidden = true;
  }

  root.querySelector("form")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (atc) {
      atc.disabled = true;
      atc.textContent = "ADDING...";
    }
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      if (!response.ok) {
        const info = await response.json().catch(() => ({}));
        throw new Error(info.description || info.message || "Could not add to cart");
      }
      const item = await response.json();
      const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((res) => res.json());
      document.querySelectorAll("[data-cart-count]").forEach((node) => {
        node.textContent = cart.item_count;
      });
      openAdded();
    } catch (error) {
      if (added) {
        added.hidden = false;
        added.textContent = error.message || "Could not add to cart";
      }
    } finally {
      if (atc) {
        atc.disabled = false;
        atc.textContent = "ADD TO CART";
      }
    }
  });

  root.querySelectorAll("[data-pdp-unit]").forEach((button) => {
    button.addEventListener("click", () => setUnit(button.dataset.pdpUnit));
  });

  const chart = root.querySelector("[data-pdp-chart]");
  const chartModal = root.querySelector("[data-pdp-chart-modal]");
  root.querySelector("[data-open-chart]")?.addEventListener("click", () => chartModal?.classList.add("is-open"));
  chartModal?.addEventListener("click", (event) => {
    if (event.target === chartModal || event.target.closest("[data-close-modal]")) chartModal.classList.remove("is-open");
  });

  const videoModal = root.querySelector("[data-pdp-video-modal]");
  const video = videoModal?.querySelector("[data-vmodal-video]");
  const quote = videoModal?.querySelector("[data-pdp-quote]");
  const sound = videoModal?.querySelector("[data-vmodal-sound]");

  function clips() {
    return Array.from(root.querySelectorAll("[data-pdp-reviews] [data-pdp-review]"));
  }

  function ensureThumbs() {
    const box = videoModal?.querySelector("[data-vmodal-thumbs]");
    if (!box || box.childElementCount) return;
    clips().forEach((card, index) => {
      const thumb = document.createElement("button");
      thumb.type = "button";
      thumb.className = "pdp-vmodal__thumb";
      thumb.innerHTML = '<img alt="" src="' + (card.dataset.poster || "") + '">';
      thumb.addEventListener("click", () => showClip(index));
      box.appendChild(thumb);
    });
  }

  function showClip(index) {
    const list = clips();
    if (!videoModal || !video || !list.length) return;
    const clipIndex = (index + list.length) % list.length;
    const card = list[clipIndex];
    const next = card.dataset.video || "";
    if (video.getAttribute("src") !== next) {
      video.src = next;
      video.poster = card.dataset.poster || "";
    }
    if (quote) quote.textContent = card.dataset.quote || "";
    videoModal.querySelectorAll(".pdp-vmodal__thumb").forEach((thumb, thumbIndex) => {
      thumb.classList.toggle("is-active", thumbIndex === clipIndex);
    });
    video.play().catch(() => {});
  }

  function closeVideo() {
    if (!videoModal) return;
    videoModal.classList.remove("is-open");
    document.body.style.overflow = "";
    if (video) video.pause();
  }

  root.querySelectorAll("[data-pdp-review]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!videoModal) return;
      ensureThumbs();
      const list = clips();
      const index = list.findIndex((item) => item.dataset.video === button.dataset.video);
      showClip(index < 0 ? 0 : index);
      videoModal.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  });
  sound?.addEventListener("click", () => {
    if (!video) return;
    video.muted = !video.muted;
    sound.classList.toggle("is-on", !video.muted);
  });
  video?.addEventListener("click", () => {
    if (video.paused) video.play().catch(() => {});
    else video.pause();
  });
  root.querySelectorAll("[data-vmodal-atc]").forEach((button) => {
    button.addEventListener("click", () => atc?.click());
  });
  videoModal?.addEventListener("click", (event) => {
    if (event.target === videoModal || event.target.closest("[data-close-modal]")) closeVideo();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeAdded();
    chartModal?.classList.remove("is-open");
    videoModal?.classList.remove("is-open");
    document.body.style.overflow = "";
    if (video) video.pause();
  });

  const place = root.querySelector("[data-pdp-place]");
  const range = root.querySelector("[data-pdp-range]");
  const flag = root.querySelector("[data-pdp-flag]");
  function addBusinessDays(from, days) {
    const date = new Date(from);
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) left -= 1;
    }
    return date;
  }
  if (range) {
    const format = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });
    const now = new Date();
    range.textContent = format.format(addBusinessDays(now, 5)) + " – " + format.format(addBusinessDays(now, 10));
  }
  if (place) {
    const lookups = [
      () => fetch("/browsing_context_suggestions.json", { credentials: "same-origin" }).then((response) => response.json()).then((data) => {
        const detected = data && data.detected_values;
        if (!detected) return "";
        return (detected.country && detected.country.name) || detected.country_name || "";
      }),
      () => fetch("https://ipwho.is/").then((response) => response.json()).then((data) => {
        if (!data || data.success === false) throw new Error("ip");
        return data.country || "";
      }),
    ];
    (async () => {
      for (const lookup of lookups) {
        try {
          const country = await lookup();
          if (country) {
            place.textContent = country;
            return;
          }
        } catch (error) {}
      }
    })();
  }

  setUnit("in");
  if (current) paint(current);
  syncOffer();
  if (chart) chart.hidden = false;
})();
